// extracted by mini-css-extract-plugin
export default {"display":"Display_display__UkQ1O","large":"Display_large__UFBwB","red":"Display_red__buc-W"};